module.exports = __webpack_public_path__ + "img/titulo2.b52deb28.png";